import { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@/common/styles/style";
import { styles } from "./style";
import BackButton from "@/atoms/backButton";
import UserProfileModify from "../modify";
import { InitializeType, ProfileType } from "../type";
import { getTimezoneLabel } from "@/helpers/getTimezoneLabel";
import { useAuth } from "@/hooks/useAuth";
import { useLoading } from "@/hooks/useLoading";
import CircularProgress from "@/molecules/circularProgress";
import { Routes } from "@/router/routes";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "@/atoms/errorMessage";

export const initializeProfile = (userData: InitializeType) => [
  { title: "名前", value: userData.name ?? "" },
  { title: "権限", value: userData.role ?? "" },
  { title: "テナント", value: userData.tenantName ?? "" },
  { title: "グループ", value: userData.groupNameList ?? "" },
  { title: "メールアドレス", value: userData.email ?? "" },
  {
    title: "タイムゾーン",
    value: userData.timezone,
  },
  { title: "パスワード", value: userData.password ?? "" },
  {
    title: "パスワード (確認用)",
    value: userData.pwConfirm ?? "",
  },
];

export default function UserProfile() {
  const navigate = useNavigate();
  const { userId } = useAuth();
  const [profileInfo, setProfileInfo] = useState<ProfileType>([]);
  const [userData, setUserData] = useState<InitializeType | null>(null);
  const [modify, setModify] = useState(false);
  const { loading, startLoading, stopLoading } = useLoading();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!modify) {
      const checkServerConnection = async () => {
        startLoading();
        try {
          const response = await fetch(`/api/profile/${userId}`, {
            method: "GET",
            credentials: "include",
          });

          const data = await response.json();
          if (response.ok) {
            console.log(data.message);
            setUserData(data.result);
            setProfileInfo(initializeProfile(data.result));
          } else if (response.status === 404) {
            alert(data.message);
            navigate(Routes.ERROR);
          } else if (response.status === 401 || response.status === 403) {
            alert(data.message);
            navigate(Routes.LOGIN);
          } else {
            setError(data.message);
          }
        } catch (error) {
          console.error("サーバ接続エラー:", error);
        } finally {
          stopLoading();
        }
      };

      checkServerConnection();
    }
  }, [modify, userId]);

  const handleEdit = () => {
    setModify(true);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.back}>
        <BackButton />
      </Box>
      <Typography variant="h3" sx={styles.profileTitle}>
        プロフィール
      </Typography>
      <ErrorMessage error={error} />
      {!modify ? (
        loading ? (
          <CircularProgress />
        ) : (
          <Box>
            {profileInfo
              .filter((info) => !info.title.includes("パスワード"))
              .map((info) => (
                <Stack
                  direction="row"
                  spacing={2}
                  sx={styles.listBox}
                  key={info.title}
                >
                  <Typography sx={styles.formControl}>{info.title}</Typography>
                  {info.title === "タイムゾーン" ? (
                    // タイトルが「タイムゾーン」の場合、idからUTCを計算して表示
                    <Typography sx={styles.formControl}>
                      {getTimezoneLabel(Number(info.value))}
                    </Typography>
                  ) : (
                    <Typography sx={styles.formControl}>
                      {info.value}
                    </Typography>
                  )}
                </Stack>
              ))}

            <Stack direction="row" spacing={2} sx={styles.buttonArea}>
              <Button
                variant="contained"
                onClick={handleEdit}
                sx={styles.button}
              >
                <Typography variant="button">編集</Typography>
              </Button>
            </Stack>
          </Box>
        )
      ) : (
        <UserProfileModify
          userId={userId}
          userData={userData as InitializeType}
          profileInfo={profileInfo}
          setProfileInfo={setProfileInfo}
          setModify={setModify}
        />
      )}
    </Box>
  );
}
